import * as types from 'store/modules/hrms1ax/mutation-types'
import hrms1ax from 'api/hrms1ax'
import swal from 'sweetalert'
import hrms1axLabels from 'assets/labels/hrms1ax'
import { hrms1axMaxRowspan, hrms1axColumns } from 'assets/columns/hrms1ax'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    labels: hrms1axLabels,
    columns: hrms1axColumns(),
    maxRowspan: hrms1axMaxRowspan,
    index: {
      total: 0,
      rows: []
    },
    response: {
      status: '',
      message: ''
    }
  },
  getters: {
    [types.GET_HRMS1AX_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS1AX_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS1AX_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS1AX_INDEX] (state) {
      return state.index
    },
    [types.GET_HRMS1AX_MAX_ROWSPAN] (state) {
      return state.maxRowspan
    }
  },
  mutations: {
    [types.SET_HRMS1AX_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS1AX_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRMS1AX_LABELS] (state, labels) {
      state.labels = labels
    },
    [types.SET_HRMS1AX_INDEX] (state, data) {
      state.index = data
    }
  },
  actions: {
    [types.TOGGLE_HRMS1AX_PAGE] ({ commit }, page) {
      let indexDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
      }
      commit(types.SET_HRMS1AX_INDEX_DISP, indexDisp)
    },
    [types.RECEIVED_HRMS1AX_COLUMNS_LABELS] ({ commit }) {
      hrms1ax.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS1AX_COLUMNS, data.labels)
          commit(types.SET_HRMS1AX_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS1AX_INDEX] ({ commit }, searchParams) {
      hrms1ax.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS1AX_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS1AX_INDEX, objData)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms1ax/index.js